import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22client-layout.tsx%22,%22import%22:%22Work_Sans%22,%22arguments%22:[{%22fallback%22:[%22sans-serif%22],%22subsets%22:[%22latin%22],%22variable%22:%22--font-work-sans%22}],%22variableName%22:%22workSans%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Work Sans', sans-serif",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
